export default __webpack_public_path__ + "assets/images/504-small.png";